// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const RegistrationStatus = t.struct({
    allowed: t.Array,
    selected: t.Array
}, 'RegistrationStatus');

export const getDefaultState = () =>
    new RegistrationStatus({
        allowed: [],
        selected: []
    });

export default RegistrationStatus;




// WEBPACK FOOTER //
// ./src/reports/registrations-review/state/registration-status.js